import moment from 'moment';
import asyncFetch from '../utils/asyncFetch';

const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const getSettings = async (token, user) => {
  try {
    const result = await asyncFetch(`${process.env.REACT_APP_BACKEND_URL}/settings`, {
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!result.user_day_filters.length) {
      result.user_day_filters = days.map(day => ({
        day,
        start: '00:00:00.000',
        end: '00:00:00.000',
        rejectAll: false,
      }));
    }
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const updateSettings = async ({ dayFilters, bufferTime, enabled, notificationEnabled, phoneNumber, token }) => {
  try {
    const result = await asyncFetch(`${process.env.REACT_APP_BACKEND_URL}/settings`, {
      method: 'PUT',
      body: {
        dayFilters,
        bufferTime,
        enabled,
        notificationEnabled,
        phoneNumber,
        localTimezone: moment().utcOffset(),
      },
      headers: { Authorization: `Bearer ${token}` },
    });
    return result;
  } catch (error) {
    console.error(error);
  }
};
